import React, { useCallback } from 'react'
import Icon from '@/components/Icon'
import { useLocalization } from '@/hooks/localization'
import { useDispatch } from '@/hooks/dispatch'
import { actionCreators } from '@/store/Identity'

const LogoutButton = React.memo(function LogoutButton ({ clean }) {
  const { localize } = useLocalization()
  const [signOut] = useDispatch([actionCreators.signOut])
  const logout = useCallback(e => {
    e.preventDefault()
    signOut(clean)
  }, [clean, signOut])

  return (
    <a className='dropdown-item' onClick={logout}><Icon name='log-out' /> {localize('Common.LogOff')}</a>
  )
})

export default LogoutButton



// WEBPACK FOOTER //
// ./src/components/auth/LogoutButton.js